export default "assets/images/flags/jp-d48bd9d9.svg";